import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { LevelForm } from "../LevelForm";
import { CreateLevelModalProps } from "./types";
import { useCreateLevelModal } from "./controller";

export const CreateLevelModal = React.memo(({ modalRef, onComplete }: CreateLevelModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateLevelModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("level_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <LevelForm />
    </Modal>
  );
});
